import { Node } from '@tiptap/core';
import { mergeAttributes } from '@tiptap/core';
export const VariantInfo = Node.create({
    name: 'variantInfo',
    group: 'block',
    atom: true,
    draggable: true,
    addAttributes() {
        return {
            variantInfo: {
                default: [
                    {
                        edit: '',
                        time: '',
                    },
                    {
                        edit: '',
                        time: '',
                    },
                ],
                renderHTML(attrs) {
                    return { 'data-variant-info': attrs.variantInfo.join(',') };
                },
                parseHTML(element) {
                    const variantInfo = element.getAttribute('data-variant-info');
                    return variantInfo?.split(',') ?? [];
                },
            },
        };
    },
    addCommands() {
        return {
            setVariantInfo: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-variant-info',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-variant-info', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=variant-info.js.map